import { render, staticRenderFns } from "./Draggable.vue?vue&type=template&id=1143ea2d&scoped=true"
import script from "./Draggable.vue?vue&type=script&lang=js"
export * from "./Draggable.vue?vue&type=script&lang=js"
import style0 from "./Draggable.vue?vue&type=style&index=0&id=1143ea2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1143ea2d",
  null
  
)

export default component.exports